import { createBrowserHistory } from 'history';
import { getRootUrl } from '../utils/getRootUrl';
const history = createBrowserHistory({
  basename: getRootUrl()
});
export function getHistory() {
  return history;
}